module.exports = __webpack_public_path__ + "img/ship.a0851949.svg";